<template>
  <div class="login">
    <form @submit="loginUser">
      <input v-model="username" placeholder="Epost"/>
      <input v-model="password" type="password" placeholder="lösenord" />
      <button @click="loginUser">Logga in</button>
      <div>{{ message }}</div>
    </form>
  </div>
</template>

<script>
import rest from "../rest";

export default {
  name: "LoginUser",
  components: {},
  data: () => {
    return {
      username: null,
      password: null,
      message: null
    };
  },
  methods: {
    loginUser() {
      rest.login(this.username, this.password).then(resp => {
        if (resp.error) {
          this.message = resp.error.message;
        }
        this.$emit("user", resp.data.data.user)
      });
    }
  }
};
</script>

<style scoped>
.login {
  text-align: left;
}
  input {
    border-radius: 5px;
    width: 150px;
  }
</style>
